module.exports = __webpack_public_path__ + "static/media/event_poster.db0112b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/event_poster.jpg
// module id = 206
// module chunks = 0